"use client";

import { createContext } from "react";
import type { LogColorType } from "@huub-web/utils";

/**
 * State for the Debug context
 */
export type DebugContextState = {
  debug: boolean;
  log: (
    color: LogColorType,
    realm: string | string[],
    ...args: unknown[]
  ) => void;
  info: (...args: unknown[]) => void;
};

/**
 * Context for managing debug state across the application
 */
export const DebugContext = createContext<DebugContextState | null>(null);
